/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';

import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { Graphql } from '@common/graphql';
import { Sttp } from '@common/sttp';
import { usePolicyId } from '../../provider';
import { apiConfig } from '@pages/ProvisionalDetailPage/config/api.config';
import { UPDATE_PAYMENT_STATUS } from '@pages/ProvisionalDetailPage/api/graphql';

export interface IUpdatePaymentPluginMethods extends IPluginMethodMap {
  getUpdatePayment(args?: any): Promise<any>;
}

export interface UpdatePaymentProps {
  paymentStatus: string;
  amount: string;
  comment: string;
  receipt?: any;
}

export class UpdatePaymentPlugin implements IAgentPlugin {
  readonly methods: IUpdatePaymentPluginMethods;

  constructor() {
    this.methods = {
      getUpdatePayment: this.getUpdatePayment.bind(this),
    };
  }

  async getUpdatePayment(args?: any) {
    await new Promise((r) => setTimeout(r, 2000));
    await this.findCapsules();
    return {
      //products: this.formatProducts(this.products),
    };
  }
  //Graphql Query example
  async findCapsules(args?: any) {
    const { userVid } = usePolicyId();
    let gql = Graphql.withBaseUrl(apiConfig.spacex_gql.url);
    // const token = getToken();
    const token = null;
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    try {
      if (client) {
        const res = await client
          .mutation(UPDATE_PAYMENT_STATUS, {
            ...args,
            paymentStatus: 'FULLY_PAID',
            amount: parseFloat(args?.amount),
            receipt: Array.isArray(args?.receipt)
              ? args?.receipt[0]?.base64
              : null,
          })
          .toPromise();
        if (res?.data) {
          return res?.data?.updatePaymentStatus;
        }
      }
    } catch (err: any) {
      log.error('error in capsules=', err?.message);
      throw err;
    }
  }
}
